module.exports = __webpack_public_path__ + "static/icon-increase-height@3x-1d53e33b70c803bfc2c2397e98b1da0a.png";